
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import Home from "./pages/Home";
import CharteVerification from "./pages/CharteVerification";
import { ThemeProvider } from "./components/theme-provider";
import Soutiens from "./pages/Soutiens";
import Actions from "./pages/Actions";
import Association from "./pages/Association";
import Adhesion from "./pages/Adhesion";
import CharteRepublicaine from "./pages/CharteRepublicaine";
import AdhesionVerification from "./pages/AdhesionVerification";
import AdhesionPaiement from "./pages/AdhesionPaiement";
import PaymentSuccess from "./pages/PaymentSuccess";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import MentionsLegales from "./pages/MentionsLegales";
import Statuts from "./pages/Statuts";
import { ScrollToTop } from "./components/ScrollToTop";
import Index from "./pages/Index";
import NewsletterVerification from "./pages/NewsletterVerification";
import Newsletter from './pages/Newsletter';
import Blog from './pages/Blog';
import IndiceCitoyennete from './pages/IndiceCitoyennete';
import { useEffect } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Login from "./pages/Login";
import Report from "./pages/Report";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/auth";
import PasswordReset from "./pages/PasswordReset";
import TikTokSignature from "./pages/TikTokSignature";
import ExprimeCharte from "./pages/ExprimeCharte";
import ExprimeCharteInscription from "./pages/ExprimeCharteInscription";
import ExprimeCharteDepot from "./pages/ExprimeCharteDepot";
import AttestationDroitImage from "./pages/AttestationDroitImage";
import GolfInscription from "./pages/GolfInscription";
import GolfVerification from "./pages/GolfVerification";
import GolfPaiement from "./pages/GolfPaiement";
import GolfSuccess from "./pages/GolfSuccess";

function App() {
  useEffect(() => {
    console.log("🚀 App initialization with detailed info:", {
      basename: "./",
      hostname: window.location.hostname,
      pathname: window.location.pathname,
      hash: window.location.hash,
      href: window.location.href,
      origin: window.location.origin,
      protocol: window.location.protocol,
      publicPath: import.meta.env.BASE_URL,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      routeMode: "browser",
      isPreview: window.location.hostname.includes("lovable") || 
                window.location.hostname.includes("preview")
    });
  }, []);

  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <AuthProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/index" element={<Index />} />
          <Route path="/home" element={<Home />} />
          <Route path="/charte-verification" element={<CharteVerification />} />
          <Route path="/charte-republicaine" element={<CharteRepublicaine />} />
          <Route path="/indice-citoyennete" element={<IndiceCitoyennete />} />
          <Route path="/soutiens" element={<Soutiens />} />
          <Route path="/association" element={<Association />} />
          <Route path="/actions" element={<Actions />} />
          <Route path="/adhesion" element={<Adhesion />} />
          <Route path="/blog" element={<Blog />} />
          <Route 
            path="/adhesion-verification" 
            element={
              (() => {
                console.log("⚠️ RENDERING /adhesion-verification ROUTE:", {
                  search: window.location.search,
                  hash: window.location.hash,
                  href: window.location.href,
                  params: new URLSearchParams(window.location.hash.split('?')[1] || ''),
                  id: new URLSearchParams(window.location.hash.split('?')[1] || '').get('id'),
                  token: new URLSearchParams(window.location.hash.split('?')[1] || '').get('token'),
                  timestamp: new Date().toISOString()
                });
                return <AdhesionVerification />;
              })()
            } 
          />
          <Route 
            path="/adhesion-paiement" 
            element={
              (() => {
                console.log("⚠️ Rendering /adhesion-paiement route with URL params:", {
                  search: window.location.search,
                  hash: window.location.hash,
                  href: window.location.href
                });
                return <AdhesionPaiement />;
              })()
            } 
          />
          <Route path="/success" element={<PaymentSuccess />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/statuts" element={<Statuts />} />
          <Route path="/newsletter-verification" element={<NewsletterVerification />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/signature" element={<TikTokSignature />} />
          <Route path="/tiktok-signature" element={<Navigate to="/signature" replace />} />
            <Route path="/exprime-la-charte" element={<ExprimeCharte />} />
            <Route path="/exprime-la-charte/inscription" element={<ExprimeCharteInscription />} />
            <Route path="/exprime-la-charte/depot" element={<ExprimeCharteDepot />} />
            <Route path="/exprime-la-charte/attestation" element={<AttestationDroitImage />} />
          <Route path="/inscription-golf2026" element={<GolfInscription />} />
          <Route path="/golf-verification" element={<GolfVerification />} />
          <Route path="/golf-paiement" element={<GolfPaiement />} />
          <Route path="/golf-success" element={<GolfSuccess />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/report" 
            element={
              (() => {
                console.log("⚠️ RENDERING /report ROUTE:", {
                  search: window.location.search,
                  hash: window.location.hash,
                  href: window.location.href,
                  timestamp: new Date().toISOString()
                });
                return (
                  <ProtectedRoute>
                    <Report />
                  </ProtectedRoute>
                );
              })()
            } 
          />
          
          <Route path="*" element={
            (() => {
              const currentPath = window.location.pathname || '/';
              console.log(`ℹ️ Route not found: ${currentPath} redirecting to home page`, {
                fullUrl: window.location.href,
                pathname: window.location.pathname
              });
              return <Navigate to="/" replace />;
            })()
          } />
        </Routes>
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
